import { render, staticRenderFns } from "./CharacterForm.vue?vue&type=template&id=11f3ea8f&scoped=true"
import script from "./CharacterForm.vue?vue&type=script&lang=js"
export * from "./CharacterForm.vue?vue&type=script&lang=js"
import style0 from "./CharacterForm.vue?vue&type=style&index=0&id=11f3ea8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f3ea8f",
  null
  
)

export default component.exports